/* VersionControlInstanceEditor.js */

"use strict";
const GameEditor = require("@gluenetworks/game_editor");
const _ = require("lodash");

class VersionControlInstanceEditor extends GameEditor {
    constructor(
        logger,
        di,
        editorState,
        editorLayoutMgr,
        userSession,
        editorTabCmpnt,
        solutionsManager
    ) {
        super(logger, di, editorState.editorState, editorLayoutMgr);
        this._logger = logger;
        this._editorTabState = editorState;
        this._userSession = userSession;
        this._tabCmpnt = editorTabCmpnt;
        this._solutionDefinition = solutionsManager.getActiveSolution();

        this._activeOrgId = this._userSession.activeOrganization.id;
        let launchOptions = editorState.launchOptions;
        this.setNamespaceGlobs([], true);

        this._config = launchOptions.config;

        this._instanceEditorState = {};
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {}

    _unregisterListeners() {}

    getTabCmpnt() {
        return this._tabCmpnt;
    }

    get config() {
        return this._config;
    }

    get activeOrgId() {
        return this._activeOrgId;
    }

    get editorTabStateId() {
        return this._editorTabState.id;
    }

    whenEditorIsReady() {
        return Promise.resolve();
    }

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    updateTab(name) {
        this._tabCmpnt.setTitle(name);
    }

    updateTabIcon(iconName) {
        this._tabCmpnt.setEditorIconName(iconName);
    }

    closeEditor(id, force) {
        id = id || this._editorTabState.id;
        return super.closeEditor(id, force);
    }

    shutdown() {
        let logger = this._logger;
        return Promise.resolve()
            .then(() => super.shutdown())
            .then(() => {
                this._logger = undefined;
                this._editorTabState = undefined;
                this._userSession = undefined;
                this._tabCmpnt = undefined;
                this._solutionDefinition = undefined;
                this._activeOrgId = undefined;
                this._config = undefined;
                this._instanceEditorState = undefined;
            })
            .catch((err) => {
                logger.warn({error: err}, "VersionControlInstanceEditor.shutdown() error");
            });
    }

    setInstanceEditorStateProperty(name, val) {
        _.set(this._instanceEditorState, name, val);
    }

    getInstanceEditorStateProperty(name) {
        return _.get(this._instanceEditorState, name);
    }

    /*******************************************/
    /* END PUBLIC COMPONENT MODEL METHODS      */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /* START PRIVATE API METHODS               */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE API METHODS                 */
    /*******************************************/
}

module.exports = VersionControlInstanceEditor;

VersionControlInstanceEditor.$inject = [
    "$teve.logger",
    "$teve.di",
    "editorLayout.editorState",
    "editorLayout.editorLayoutMgr",
    "$teve.userSession",
    "editorLayout.editor.tabComponent",
    "$teve.solutionsManager",
];

//Optional convenient way to set a tab icon.
VersionControlInstanceEditor.$editorIcon = "fileserver.file";
VersionControlInstanceEditor.$editorIconType = "base-icon-gl";
